export enum NumberTypeEnum {
    INTEGER = 0,    // -> 0
    DOUBLE = 1,      // -> 1
    UNKNOWN = 2,
}
